import { Button } from '@material-ui/core'
import Box from '@mui/material/Box'
import React from 'react'
import SpinnerIcon from '../../../assests/icons/SpinnerIcon'

const ButtonSpinner = (props) => {
    const { isLoading, disabled, label = 'Submit', type = 'submit', onclick, className, sx } = props

    return (
        <Box
            sx={{
                m: 1,
                position: 'relative',
                ...sx,
            }}>
            <Button
                disabled={disabled}
                id="auto-submit-btn"
                type={type}
                variant="contained"
                className={className ? className : 'btn-primary'}
                onClick={onclick}>
                {label}
            </Button>
            {isLoading && (
                <SpinnerIcon
                    style={{
                        position: 'absolute',
                        top: '22%',
                        left: '6%',
                    }}
                />
            )}
        </Box>
    )
}

export default ButtonSpinner
